import EmployeeLetters from "../../../../src/pages/use-cases/page-content/content-publishing/employee-letters.md";
import * as React from 'react';
export default {
  EmployeeLetters,
  React
};